import { useNavigate } from 'react-router-dom';

import { redactEmail, redactPhone } from '../utils/redaction-utils';

import { useAuthentication } from './auth-provider';
import { confirmVerificationCode, resendVerificationCode, VerificationMethod } from './verification-client';

type ServiceUserContact = {
  email?: string | null;
  phoneNumber?: string | null;
};

const getDeliveryAddress = (method: VerificationMethod, serviceUser?: ServiceUserContact) => {
  const address = method === 'phone' ? serviceUser?.phoneNumber : serviceUser?.email;
  if (!address) return undefined;
  return method === 'phone' ? redactPhone(address) : redactEmail(address);
};

const useAccountVerification = ({
  method,
  redirect,
  serviceUser,
}: {
  method: VerificationMethod;
  redirect?: string;
  serviceUser?: ServiceUserContact;
}) => {
  const { apiUrl } = useAuthentication();
  const navigate = useNavigate();

  const handleCodeSubmit = async (code: string) => {
    try {
      await confirmVerificationCode(apiUrl, code, method);
      navigate(redirect ?? '/', { replace: true });
    } catch {
      throw new Error('account verification failed');
    }
  };

  const handleResend = async () => {
    await resendVerificationCode(apiUrl, method);
  };

  return { deliveryAddress: getDeliveryAddress(method, serviceUser), handleCodeSubmit, handleResend };
};

export type { ServiceUserContact };
export { useAccountVerification };
